/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Tobacco = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="12"
    height="20"
    fill="none"
    viewBox="0 0 12 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.836 19.2864C4.8 18.0024 4.1856 17.3784 2.9496 16.2384C1.8504 15.2256 1.1568 14.3592 0.7008 13.4328C0.2232 12.4608 0 11.3904 0 10.0632C0 8.11199 0.4584 6.34559 1.404 4.6632C2.3232 3.024 3.6816 1.4976 5.5584 0C7.4352 1.4976 8.7936 3.024 9.7128 4.6632C10.656 6.34799 11.1168 8.11439 11.1168 10.0632C11.1168 11.3904 10.8936 12.4608 10.416 13.4328C9.96 14.3592 9.2664 15.2256 8.1672 16.2384C6.9288 17.3784 6.3168 18.0024 6.2808 19.2864H4.836ZM5.4792 1.9416C2.8056 4.3128 1.5072 6.96959 1.5072 10.0632C1.5072 12.9192 2.5728 13.9176 3.8064 15.072C4.0752 15.324 4.3536 15.5832 4.632 15.8736L4.8384 16.0872V12.7584C4.8384 11.1936 4.2264 10.1208 3.1152 9.72239L3.54 8.35199C3.9312 8.48639 4.3032 8.68799 4.6464 8.95199L4.8384 9.10079V4.77359H6.2784V9.09839L6.4704 8.94959C6.8136 8.68559 7.1856 8.48639 7.5768 8.34959L8.0016 9.72239C6.888 10.1256 6.276 11.1984 6.276 12.7584V16.0872L6.4824 15.8736C6.7608 15.5832 7.0392 15.324 7.308 15.072C8.5416 13.9176 9.6072 12.9192 9.6072 10.0632C9.6072 6.96959 8.3088 4.3128 5.6352 1.9416L5.556 1.872L5.4792 1.9416Z" fill="currentColor" />
  </svg>
);

Tobacco.propTypes = propTypes;

export default Tobacco;
